/* src/app/modules/user/partnersequity/related-companies/related-companies-list.component.css */
/*# sourceMappingURL=related-companies-list.component.css.map */
